<template>
<div style="height:100vh" class="dabeijing">
<div class="login_methods">
<div class="login_wx">
<div class="login">
  <div class="title">
    <h3 class="tab-title" @click="switchTo('password')"
    :class="{ 'is-active': activeMethod == 'password' }">密码登录</h3>
    <h3 class="tab-title" @click="switchTo('sms')"
    :class="{ 'is-active': activeMethod == 'sms' }">短信登录</h3>
  </div>
  <!-- 密码登录 -->
  <div v-show="activeMethod == 'password'">
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px"
      class="demo-ruleForm card-box loginform">
      <el-form-item prop="account" class="account">
        <input :disabled="isdisabled" type="text" v-model="ruleForm2.account" placeholder="账号" maxlength="11"/>
        <div><img src="../assets/img/bicon27.png" alt style="width: 20px;"/></div>
      </el-form-item>
      <el-form-item prop="checkPass" class="account">
        <input type="password" v-model="ruleForm2.checkPass" placeholder="密码" :disabled="isdisabled" @keyup.enter="handleSubmit2"/>
        <div><img src="../assets/img/bicon30.png" alt style="width: 20px;"/></div>
      </el-form-item>
    
      <el-form-item style="width:100%;">
        <el-button @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
  <!-- 短信登录 -->
  <div v-show="activeMethod == 'sms'">
    <el-form :model="ruleForm3" status-icon :rules="rules3" ref="ruleForm3"
      label-position="left" label-width="0px" class="demo-ruleForm card-box loginform">
      <!-- <el-form-item prop="pass" class="account">
        <input type="password" v-model="ruleForm3.pass" placeholder="请输入密码,区分大小写"/>
        <div><img src="../assets/img/bicon32.png" alt style="width: 20px;"/></div>
      </el-form-item>
      <el-form-item prop="checkPass" class="account">
        <input type="password" v-model="ruleForm3.checkPass" placeholder="请重新输入新设置密码"/>
        <div><img src="../assets/img/bicon32.png" alt style="width: 20px;"/></div>
      </el-form-item> -->
      <el-form-item prop="accountPhone" class="account">
        <input v-model.number="ruleForm3.accountPhone" placeholder="请输入手机号" maxlength="11"/>
        <div><img src="../assets/img/bicon31.png" alt style="width: 20px;"/></div>
      </el-form-item>
      <el-form-item prop="code" class="code">
        <input v-model="ruleForm3.code" placeholder="请输入验证码" maxlength="6" style="width:123px;"/>
        <button @click.prevent="getcode()" class="codenumber" :class="{ 'active': countdownActive }">
          {{ countdownActive ? `${countdown} 秒后重新发送` : '获取验证码' }}
        </button>
        <div><img src="../assets/img/bicon32.png" alt style="width: 20px;"/></div>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button @click="submitForm('ruleForm3')">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
  
</div>
</div>
</div>
</div>
</template>
<script>
import { ApiLogin, sendLoginCode, loginbycode, loginout } from "../api/newOss";
export default {
  name: "logining",
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("请输入手机号"));
    //   } else {
    //     if (this.ruleForm3.accountPhone !== "") {
    //       this.$refs.ruleForm3.validateField("accountPhone");
    //     }
    //     callback();
    //   }
    // };
    // var validatePass2 = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("请再次输入密码"));
    //   } else if (value !== this.ruleForm3.pass) {
    //     callback(new Error("两次输入密码不一致!"));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      checked:false,
      checked1:false,
      isdisabled:false,
      PhoneNumber: "",
      codestyle: true,
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: "",
        code: 1
      },
      countdown: 60, // 倒计时初始秒数
      countdownActive: false, // 倒计时是否正在进行
      timer: null, // 用于存储定时器的引用
      ruleForm3: {
        accountPhone: '',
        code: '',
        // pass: "",
        // checkPass: "",
        // age: ""
      },
      rules2: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      rules3: {
        // checkPass: [{ validator: validatePass2, trigger: "blur" }],
        // accountPhone: [{ validator: validatePass, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      checked: true,
      activeMethod: 'password'
    };
  },
  methods: {
    switchTo(val) {
      this.activeMethod = val;
      if (this.$refs.ruleForm3) {
        this.$refs.ruleForm3.resetFields();
      }
    },
    // 登录
    handleSubmit2(ev) {
      if(this.checked+""=="false"&&this.checked1+""=="false"){
        this.$swal({
          type:"warning",
          text:"请选择登陆身份"
        })
        return false
      }
      var _this = this;
      localStorage.removeItem("token");
      localStorage.removeItem("userkey");
      _this.$cookie.remove("parentId", "");
      _this.$cookie.remove("menuId", "");
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          _this.logining = true;

          var loginParams = {
            loginname: this.ruleForm2.account, // 登录账号
            loginpwd: this.ruleForm2.checkPass, // 登录密码
          };
          ApiLogin(loginParams).then(data => {
            let thisToken = data.resultObj.token; // 生成的token
            let thisInfo = data.resultObj.info; // 用户信息
            let thisUserkey = data.resultObj.userkey; // userkey
            localStorage.setItem("currentPath", "/banner");
            localStorage.setItem("token", thisToken); // token
            localStorage.setItem("userkey", thisUserkey); // userkey
            
            localStorage.setItem("Id", thisInfo.userid); // 用户ID
            localStorage.setItem("Name", thisInfo.username); // 用户姓名
            localStorage.setItem("Phone", thisInfo.phone); // 手机号
            localStorage.setItem("enterpriseid", thisInfo.enterpriseid); // 所属企业ID
            localStorage.setItem("BbId", thisInfo.shopid); // 所属店铺ID
            
            // localStorage.setItem("loginInfo", thisInfo); // info 用户信息
            localStorage.setItem("isadmin", thisInfo.isadmin); // 是否是超级管理员 0=否 1=是
            localStorage.setItem("isplatformadmin", thisInfo.isplatformadmin); // 是否是平台(全国)管理员 0=否 1=是
            localStorage.setItem("iscityadmin", thisInfo.iscityadmin); // 是否是城市管理员(城市分公司) 0=否 1=是
            localStorage.setItem("isenterpriseadmin", thisInfo.isenterpriseadmin); // 是否是企业管理员 0=否 1=是
            localStorage.setItem("isshopadmin", thisInfo.isshopadmin); // 是否是店铺管理员 0=否 1=是

            localStorage.setItem("scid", thisInfo.scid); // 区县id

            // _this.$cookie.set("loginInfo", thisInfo); // 用户信息
            _this.$cookie.set("OperatorId", thisInfo.userid);
            _this.$cookie.set("Name", thisInfo.username);
            _this.$cookie.set("Phone", thisInfo.phone);
            
            _this.$router.replace("/welcome"); // 欢迎首页
            _this.logining = false;
            this.PhoneNumber = thisInfo.phone;
          }).catch(err => {
            this.logining = false;
          });
        } else {
          return false;
        }
      });
    },
    // 获取验证码
    getcode() {
      if (this.countdownActive) return; // 如果倒计时正在进行，不执行操作
      if (!this.ruleForm3.accountPhone) {
        this.$message({
          message: '请先输入手机号',
          type: "error"
        });
        return;
      }
      this.countdownActive = true;
      var obj = {
        phone: this.ruleForm3.accountPhone,
      };
      sendLoginCode(obj).then(data => {
        if (data.resultCode == 1) {
          this.$message({
            message: data.resultMsg,
            type: "success"
          });
          this.timer = setInterval(() => {
            if (this.countdown === 0) {
              clearInterval(this.timer); // 清除定时器
              this.countdownActive = false;
              this.countdown = 60; // 重置倒计时
            } else {
              this.countdown--;
            }
          }, 1000);
        } else {
          return false;
        }
      }).catch(error => {
        // console.error("获取data失败:", error);
        clearInterval(this.timer); // 清除定时器
        this.countdownActive = false;
        return false;
      });
    },
    // 验证码 登录
    submitForm(formName) {
      if (!this.ruleForm3.accountPhone) {
        this.$message({
          message: '请先输入手机号',
          type: "error"
        });
        return;
      }
      var _this = this;
      localStorage.removeItem("token");
      localStorage.removeItem("userkey");
      _this.$cookie.remove("parentId", "");
      _this.$cookie.remove("menuId", "");
      this.$refs[formName].validate(valid => {
        if (valid) {
          var obj = {
            phone: this.ruleForm3.accountPhone, // 手机号
            code: this.ruleForm3.code, // 验证码
          };
          loginbycode(obj).then(data => {
            if (data.resultCode == 1) {
              let thisToken = data.resultObj.token; // 生成的token
              let thisInfo = data.resultObj.info; // 用户信息
              let thisUserkey = data.resultObj.userkey; // userkey
              localStorage.setItem("currentPath", "/banner");
              localStorage.setItem("token", thisToken); // token
              localStorage.setItem("userkey", thisUserkey); // userkey
              
              localStorage.setItem("Id", thisInfo.userid); // 用户ID
              localStorage.setItem("Name", thisInfo.username); // 用户姓名
              localStorage.setItem("Phone", thisInfo.phone); // 手机号
              localStorage.setItem("enterpriseid", thisInfo.enterpriseid); // 所属企业ID
              localStorage.setItem("BbId", thisInfo.shopid); // 所属店铺ID
              
              // localStorage.setItem("loginInfo", thisInfo); // info 用户信息
              localStorage.setItem("isadmin", thisInfo.isadmin); // 是否是超级管理员 0=否 1=是
              localStorage.setItem("isplatformadmin", thisInfo.isplatformadmin); // 是否是平台(全国)管理员 0=否 1=是
              localStorage.setItem("iscityadmin", thisInfo.iscityadmin); // 是否是城市管理员(城市分公司) 0=否 1=是
              localStorage.setItem("isenterpriseadmin", thisInfo.isenterpriseadmin); // 是否是企业管理员 0=否 1=是
              localStorage.setItem("isshopadmin", thisInfo.isshopadmin); // 是否是店铺管理员 0=否 1=是

              // _this.$cookie.set("loginInfo", thisInfo); // 用户信息
              _this.$cookie.set("OperatorId", thisInfo.userid);
              _this.$cookie.set("Name", thisInfo.username);
              _this.$cookie.set("Phone", thisInfo.phone);
              
              _this.$router.replace("/welcome"); // 欢迎首页
              this.PhoneNumber = thisInfo.phone;
              clearInterval(this.timer); // 清除定时器
              this.countdownActive = false;
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted(){
    localStorage.removeItem("token");
    localStorage.removeItem("Id");
    localStorage.removeItem("userkey");
  },
};
</script>
<style scoped>
.dabeijing {
  background: url("../assets/img/dabeijing.png") no-repeat;
  background-size:cover;
  background-attachment:fixed;
}
.nextBut {
  background: #bfbfbf;
  color: #fff;
}
/* 中间 登录 */
.login_methods {
  height: 75%;
  background-size:100% 100%;
}

.login_wx {
  width: 60%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.login_wx .login {
  width: 362px;
  padding: 15px 10px;
  background: #fff;
  box-shadow: 0px 0px 15px 1px rgba(0,0,0,0.07);
  border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 40%;
  right: 0;
  text-align: center;
}

/* 账号 密码 输入框 */
.login input {
  width: 258px;
  height: 43px;
  border: solid 1px #bfbfbf;
  border-radius: 4px;
  outline: none;
  padding: 0 0 0 40px;
  color: #706f6f;
}
.login .account {
  position: relative;
  width: 83%;
  margin-left: 30px;
}
/* 图标 */
.account div {
  position: absolute;
  top: 0;
  left: 12px;
}
.code div {
  position: absolute;
  top: 0;
  left: 40px;
}
/* 登录按钮 */
.login_methods .login .el-button {
  width: 300px;
  border-radius: 5px;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  background: #FB5442;
  border: none;
}
/* 账户登录 */
.login .title {
  text-align: center;
  padding-bottom: 5px;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  font-size: 16px;
  font-weight: normal;
  display: flex;
  margin-bottom: 25px;
  justify-content: space-evenly;
}
/* 密码登录 & 短信登录 */
.tab-title {
  cursor: pointer;
  
}

.is-active {
  color: #F56C6C;
}
/* 获取验证码 */
.codenumber {
  display: inline-block;
  width: 122px;
  height: 45px;
  border: solid 1px #F56C6C;
  border-radius: 4px;
  color: #F56C6C;
  line-height: 0;
  margin-left: 10px;
  cursor: pointer;
  background: none;
}
.codenumber.active {
  border-color: #bfbfbf;
  color: #888;
}
</style>


// WEBPACK FOOTER //
// Login.vue?3272cec2